/**
 * Hard-coded demo tree for Atlas front-end chunks (before live wiring).
 * Used only when explicitly requested — live Atlas prefers real folders.
 */

export const DEMO_FOLDERS = [
  { id: 'demo-company', name: 'Company', parentId: null, docCount: 2 },
  { id: 'demo-product', name: 'Product', parentId: 'demo-company', docCount: 4 },
  { id: 'demo-specs', name: 'Specs', parentId: 'demo-product', docCount: 3 },
  { id: 'demo-meetings', name: 'Meetings', parentId: 'demo-product', docCount: 5 },
  { id: 'demo-legal', name: 'Legal', parentId: 'demo-company', docCount: 2 },
  { id: 'demo-contracts', name: 'Contracts', parentId: 'demo-legal', docCount: 6 },
  { id: 'demo-ops', name: 'Ops', parentId: null, docCount: 1 },
  { id: 'demo-hire', name: 'Hiring', parentId: 'demo-ops', docCount: 3 },
];

export const DEMO_DOCS_BY_FOLDER = {
  'demo-specs': [
    { id: 'd1', title: 'Auth overview', icon: '📄', tags: [] },
    { id: 'd2', title: 'API surface', icon: '📄', tags: [] },
    { id: 'd3', title: 'Mission scratch', icon: '📝', tags: ['mission-notes'] },
    { id: 'd4', title: 'Internal pricing', icon: '🔒', tags: ['admin-only'] },
    { id: 'd5', title: 'Edge cases', icon: '📄', tags: [] },
    { id: 'd6', title: 'Migration notes', icon: '📝', tags: ['mission-notes'] },
  ],
  'demo-contracts': [
    { id: 'c1', title: 'MSA template', icon: '📄', tags: [] },
    { id: 'c2', title: 'NDA — Partner A', icon: '📄', tags: [] },
    { id: 'c3', title: 'NDA — Partner B', icon: '📄', tags: [] },
    { id: 'c4', title: 'Admin clause pack', icon: '🔒', tags: ['admin-only'] },
    { id: 'c5', title: 'Runbook link', icon: '📝', tags: ['mission-notes'] },
    { id: 'c6', title: 'Renewal checklist', icon: '📄', tags: [] },
    { id: 'c7', title: 'Vendor X', icon: '📄', tags: [] },
  ],
  'demo-meetings': [
    { id: 'm1', title: 'Kickoff', icon: '📄', tags: [] },
    { id: 'm2', title: 'Weekly sync', icon: '📄', tags: [] },
  ],
};
